// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__F5uv-","row":"styles_row__2VGHS"};